/**
 * FullAgenda Component
 * 
 * Admin agenda page displaying all wedding events after authentication.
 * Shows comprehensive event information with scroll animations.
 * Organized by date with decorative headers and event cards.
 */

import React from 'react';
import '../App.css';

// Shared Components
import ProtectedPageLayout from '../components/shared/ProtectedPageLayout';
import HeroSection from '../components/shared/HeroSection';
import VenueSection from '../components/shared/VenueSection';
import GradientContainer from '../components/shared/GradientContainer';
import ClosingSection from '../components/shared/ClosingSection';

// Specific Components and Utilities
import EventCard from '../components/EventCard';
import { groupEventsByDate, getDateHeaderInfo } from '../utils/eventUtils';
import { PAGE_EVENTS } from '../data/eventsData';

function FullAgenda() {
  // Get all events from centralized data source
  const events = PAGE_EVENTS.home();
  
  // Group events by date for organized display
  const eventsByDate = groupEventsByDate(events);
  
  // Sort dates chronologically for proper display order
  const sortedDates = Object.keys(eventsByDate).sort((a, b) => {
    // Parse dates for proper sorting (handle ordinal suffixes)
    const dateA = new Date(a.replace(/(\\d+)(st|nd|rd|th)/, '$1'));
    const dateB = new Date(b.replace(/(\\d+)(st|nd|rd|th)/, '$1'));
    return dateA - dateB;
  });

  return (
    <ProtectedPageLayout authPath="/fllagnd8293kxm" useScrollAnimations={true}>
      {/* Hero Section with Wedding Branding */}
      <HeroSection />

      <GradientContainer variant="default">
        {/* Venue Information with Location Icon */}
        <VenueSection title="Wedding Venue" showIcon={true} />

        {/* Events Section - Organized by Date */}
        <div className="agenda">
          {sortedDates.map((date, dateIndex) => {
            const headerInfo = getDateHeaderInfo(date);
            
            return (
              <div key={date}>
                {/* Date Header with Decorative Elements */}
                <div className="day-section">
                  <div className="day-header">
                    <h2>{headerInfo.title}</h2>
                    <div className="date-ornament">
                      <span className="ornament">{headerInfo.ornament}</span>
                      <span className="date">{date}</span>
                      <span className="ornament">{headerInfo.ornament}</span>
                    </div>
                  </div>
                </div>

                {/* Event Cards for Current Date */}
                {eventsByDate[date].map((event, eventIndex) => (
                  <EventCard 
                    key={event.id} 
                    event={event} 
                    isReversed={eventIndex % 2 === 1} // Alternate card layout
                  />
                ))}
              </div>
            );
          })}
        </div>

        {/* Closing Section with Call to Action */}
        <ClosingSection variant="simple" />
      </GradientContainer>
    </ProtectedPageLayout>
  );
}

export default FullAgenda;